var tempImage = '';
// var tempSrcSet = '';
var tempColorId = '';
var gettingVEPA = false;





// HTML ELEMENTS
const errorDisplay = document.getElementById('errorDisplay');

const colorOptions = document.querySelectorAll('input[name="color"]');
const colorOptionText = document.getElementById('colorOption');

const description = document.getElementById('productDescription');


let productVariants = window.productVariants

const isSingleColor = colorOptions.length === null || colorOptions.length === 0;

colorOptions.forEach(colorOption => {
	colorOption.addEventListener('click', () => {
		colorOptionText.textContent = colorOption.value;
	});
});

function getProductVariantId(color, size) {
	if (size == null || size === 'undefined' || size === '') {
		size = Object.keys(productVariants.color[color].size)[0];
		// console.log(Object.keys(productVariants.color[color].size));
	}

	if (color && size) {
		if (color in productVariants.color) {
			if (!(size in productVariants.color[color].size)) {
				size = Object.keys(productVariants.color[color].size)[0];
			}
			if (size in productVariants.color[color].size) {

				if (gettingVEPA == false) {
					gettingVEPA = true;
				} else {
					return false;
				}

				fetch("/product_info_ajax.php?products_id=" + productVariants.color[color].size[size])
					.then(response => {
						if (!response.ok) {
							throw new Error(`HTTP error! status: ${response.status}`);
						}
						return response.json();
					})
					.then(data => {
						try {
							gettingVEPA = false;
							productVariants = data.variants;

							document.getElementById("products_name").innerHTML = data.products_name;

							let finalPrice = parseFloat(data.final_price).toLocaleString('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}),
								productsPrice = parseFloat(data.products_price).toLocaleString('en-US', {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2
								});
							if (productsPrice > finalPrice) { // isSale = true
								document.getElementById("products_price").innerHTML = '<s class="text-muted">$' + productsPrice + '</s>&nbsp;' +
									'<strong>SALE:</strong> <span itemprop="price">$' + finalPrice + '</span>';
							} else {
								document.getElementById("products_price").innerHTML = '<span itemprop="price">$' + productsPrice + '</span>';
							}

							if (data.coupon) {
								document.getElementById("couponsInfo").innerHTML = data.coupon;
							}

							description.innerHTML = data.products_description;

							if (data.images.length > 0) {
								updateProductImages(data.images);
							} else {
								// We just neeed to update the main image
								updateSingleProductImage(data.products_image, data.products_name);
							}


							document.getElementById("products_model").innerHTML = '#' + data.products_model;
							document.querySelector('input[name="products_id"]').value = data.products_id;

							document.getElementById("checkoutButtons").setAttribute("action", data.action);
							document.querySelectorAll("input[name='products_id']").forEach(function (input) {
								input.value = data.products_id;
							});


							if (data.options && Object.keys(data.options).length > 0) {

								// Load the new url
								window.location = `/-p-${data.products_id}.html`

							}

							updateProductName();


							let colorInputs = document.getElementsByClassName("products_colors");
							for (let elem of colorInputs) {
								elem.checked = false;
							}
							for (let elem of colorInputs) {
								if (elem.value === data.data_color) {
									elem.checked = true;
									break;
								}
							}

							if (data.data_size) {
								size = data.data_size.toUpperCase();
							}

							if (size == "") {
								size = "0";
							}

							if (data.status == 0) {
								document.getElementById("outOfStockMessage").classList.remove("d-none");
								let successButtons = document.querySelectorAll(".buy-btn");
								for (let btn of successButtons) {
									btn.disabled = true;
								}

							} else {
								document.getElementById("outOfStockMessage").classList.add("d-none");
								let successButtons = document.querySelectorAll(".buy-btn");
								for (let btn of successButtons) {
									btn.disabled = false;
								}
							}
							if (productVariants.color[color].products_status[size] === '0') {
								// document.getElementById("current-size").style.display = "block";
								errorDisplay.style.display = 'block';
								errorDisplay.innerHTML = 'This product is out of stock';
								disableBuyButton();
								if (document.querySelector('.in-stock-indicator') != null) {

									document.querySelector('.in-stock-indicator').style.display = 'none';
								}
							} else {
								// document.getElementById("current-size").style.display = "block";
								errorDisplay.style.display = 'none';
								enableBuyButton();
								if (document.querySelector('.in-stock-indicator') != null) {
									document.querySelector('.in-stock-indicator').style.display = 'block';
								}

							}

							if (productVariants.selected_size === "" && productVariants.color[color].products_status === '0') {
								// $("#out-of-stock-color").show();
							} else {
								// $("#out-of-stock-color").hide();
								// $(".current-size").css("color", "black");
							}



							// Get the size select
							let sizeSelect = document.getElementById('sizeSelect');
							if (sizeSelect != null) {
								// Clear the size select
								sizeSelect.innerHTML = '';
								// Loop through the sizes
								for (let [key, value] of Object.entries(productVariants.color[color].size)) {
									let disabled = productVariants.color[color].products_status[key] === '0';
									// Create a new option element
									let option = document.createElement('option');
									// Set the value of the option
									option.value = key;
									// Set the text of the option
									option.textContent = key + (disabled ? ' [OUT OF STOCK]' : '');
									// If the size is out of stock
									if (disabled) {
										// Set the disabled attribute
										option.setAttribute('disabled', true);
									}

									// Select the size if it matches the current size
									if (key === size) {
										option.setAttribute('selected', true);
									}


									// Append the option to the size select
									sizeSelect.appendChild(option);
								}
							}



							history.pushState({
								id: data.products_id
							}, data.products_name, data.products_name.split(' ').join('-').split('%').join('') + '-p-' + data.products_id + '.html');
							document.title = data.products_model + ' | ' + data.products_name;


							document.getElementById('current-size').setAttribute('data-current-size', size)
							document.getElementById('current-size').innerHTML = size;


							document.querySelector('.loader-spinner').style.display = "none";
						} catch (error) {
							console.error('There was an error fetching the product data:', error);
							throw error;
						}
					})
					.catch(error => {
						document.querySelector('.loader-spinner').style.display = "none";
						alert('Error occurred!');
						console.error('There was an error fetching the product data:', error);
					});
			}
		}

	}
	document.querySelector('.loader-spinner').style.display = 'none';
}

/**
 * Util functions
 */


const selectedColor = () => {
	return productVariants.selected_color;
}



const selectedSize = () => {
	return productVariants.selected_size;

}


// Used mostly when selected a different color
function updateProductName() {
	let title = document.getElementById('products_name').textContent;

	if (!isSingleColor) {
		if (colorOptionText.textContent != '') {
			title = `${title} - ${colorOptionText.textContent}`;
		}
	}


	document.getElementById('products_name').innerHTML = title;
}


function disableBuyButton() {
	document.querySelectorAll('.buy-btn').forEach(function (btn) {
		btn.setAttribute('disabled', true);
	});
}

function enableBuyButton() {
	document.querySelectorAll('.buy-btn').forEach(function (btn) {
		btn.removeAttribute('disabled');
	});
}




const updateSingleProductImage = (image, alt) => {
	document.querySelector('#img_first a.gallery-item').href = image;
	document.querySelector('#img_first img').src = image;
	document.querySelector('#img_first img').alt = alt;

	// Remove srcset. In the future, we should add it back
	document.querySelector('#img_first img').removeAttribute('srcset');
}



async function updateProductImages(images) {

	if (images.length === 0) {
		return;
	}

	let carouselEl = document.querySelector('.product-gallery-thumblist .swiper');

	let productGallery = document.querySelector('.product-gallery .product-gallery-preview');


	let productThumbSwiper = window.productThumbSwiper || null;
	// Clear the existing images
	// carouselEl.innerHTML = '';
	if (productThumbSwiper && productThumbSwiper.slides.length > 0) {
		productThumbSwiper.removeAllSlides();
	}

	// Preload the image, this is to prevent the image from flickering
	try {
		if (images.length > 0) {
			await preloadImage(images[0].src);
			productGallery.innerHTML = '';
		}

		images.forEach((image, index) => {
			let imgActive = '';
			let indexHref = index;
			if (index === 0) {
				imgActive = 'active';
				indexHref = 'first';
			}

			const thumbEl = document.createElement('a');
			thumbEl.className = `product-gallery-thumblist-item swiper-slide ${imgActive}`;
			thumbEl.href = `#img_${indexHref}`;


			const imgElement = document.createElement('img');
			imgElement.width = "100";
			imgElement.height = "80";
			imgElement.className = "";
			imgElement.src = image.src;
			imgElement.setAttribute('data-src', image.src);
			imgElement.alt = image.alt;
			imgElement.loading = "lazy";

			thumbEl.appendChild(imgElement);
			// carouselEl.appendChild(thumbEl);

			if (productThumbSwiper) {
				productThumbSwiper.appendSlide(thumbEl);
			}


			// Update Product Gallery
			const productImageDiv = document.createElement('div');
			productImageDiv.className = `product-gallery-preview-item ${imgActive}`;
			productImageDiv.id = `img_${indexHref}`;


			const aElement2 = document.createElement('a');
			aElement2.className = 'gallery-item';
			aElement2.href = image.src;

			const galleryItemImg = document.createElement('img');
			galleryItemImg.className = 'img-fluid';
			galleryItemImg.src = image.src;
			galleryItemImg.alt = image.alt;

			aElement2.appendChild(galleryItemImg);

			productImageDiv.appendChild(aElement2);
			if (index === 0) {
				productGallery.innerHTML = '';

			}
			productGallery.appendChild(productImageDiv);

			thumbEl.addEventListener('click', (e) => {
				e.preventDefault();
				let thumbnails = carouselEl.querySelectorAll('.product-gallery-thumblist-item:not(.video-item)');
				let previews = productGallery.querySelectorAll('.product-gallery-preview-item')

				for (let i = 0; i < thumbnails.length; i++) {
					previews[i].classList.remove('active');
					thumbnails[i].classList.remove('active');
				}
				thumbEl.classList.add('active');
				productImageDiv.classList.add('active');

			});



		});







		// Remove the existing lightGallery instance
		let gallery = document.querySelector('.gallery');
		gallery.removeAttribute('lg-uid');


		lightGallery(document.querySelector(".gallery"), {
			selector: '.gallery-item',
			download: false,
			videojs: true,
			youtubePlayerParams: {
				modestbranding: 1,
				showinfo: 0,
				rel: 0
			},
			vimeoPlayerParams: {
				byline: 0,
				portrait: 0,
				color: 'fe696a'
			}
		});

	} catch (error) {
		console.error('Error preloading image:', error);
	}
	// for (let n = 0; n < thumbnails.length; n++) {
	//   thumbnails[n].addEventListener('click', changePreview);
	// }

	// // Changer preview function
	// function changePreview(e) {
	//   e.preventDefault();
	//   for (let i = 0; i < thumbnails.length; i++) {
	// 	previews[i].classList.remove('active');
	// 	thumbnails[i].classList.remove('active');
	//   }
	//   this.classList.add('active');
	//   gallery[i].querySelector(this.getAttribute('href')).classList.add('active');
	// }


}
function tep_watermark_url(filename, size = null) {
	const baseUrl = window.location.origin;

	let params = {}

	if (size) {
		params['size'] = size;
	}

	let urlParams = new URLSearchParams(params);
	return `${baseUrl}/wm.php${filename}?${urlParams.toString()}`;



}

/**
 * Helper function to display an error message
 * 
 * @param {string} message 
 */
function displayError(message) {
	errorDisplay.style.display = 'block';
	errorDisplay.innerHTML = message;
}

/**
 * Helper function to hide the error message
 */
function hideError() {
	errorDisplay.style.display = 'none';
	errorDisplay.innerHTML = '';
}

// If color is an option, we need to append it to the title
if (colorOptionText != null && colorOptionText.textContent != '') {
	updateProductName();
}

if (document.getElementById('sizeSelect') == null) {
	if (errorDisplay != null) {
		hideError();
	}
}

if (document.getElementById('sizeSelect') != null) {
	if (document.getElementById('sizeSelect').value == 'Select a Size') {
		displayError('Please select a size');
	}

}


const preloadImage = src =>
	new Promise((resolve, reject) => {
		const image = new Image();
		image.onload = resolve;
		image.onerror = (error) => {
			console.error('Error preloading image:', src, error);
			reject(error);
		};
		image.src = src;
	});




document.addEventListener("DOMContentLoaded", function () {

	// VEPA Products
	// Color and size options
	var dots = document.getElementsByClassName("dot");
	for (var i = 0; i < dots.length; i++) {
		dots[i].disabled = true;
	}

	document.querySelectorAll('.dot').forEach(function (dot) {
		dot.addEventListener('click', function () {
			tempImage = '';
			let colorId = this.getAttribute('data-color-id');
			let sizeId = selectedSize();

			document.querySelector('.loader-spinner').style.display = 'block';
			getProductVariantId(colorId, sizeId);
		});
	});

	// When the size select changes
	if (document.getElementById('sizeSelect') != null) {
		document.getElementById('sizeSelect').addEventListener('change', function () {
			// Get the size from the select
			let sizeId = this.value;
			let currentSize = document.getElementById('current-size');
			currentSize.setAttribute('data-current-size', sizeId);
			currentSize.innerHTML = sizeId;

			let colorId = selectedColor();

			document.querySelector('.loader-spinner').style.display = 'block';
			getProductVariantId(colorId, sizeId);
		});
	}



	// Product status check
	if (productStatus == '0') {
		document.querySelectorAll('.btn-success').forEach(function (btn) {
			btn.setAttribute('disabled', true);
		});
		document.querySelector('current-size').style.color = 'grey';
	}

	// Mouseover and mouseout events for .dot
	document.querySelectorAll('.dot').forEach(function (dot) {
		dot.addEventListener('mouseover', function () {
			if (tempImage == '') {
				// tempImage = document.querySelector('#img_first  img').getAttribute('src');
				// tempSrcSet = document.querySelector('#img_first  img').getAttribute('srcset');
				tempColorId = document.querySelector('#colorOption').innerHTML;
			}
			// document.querySelector('#img_first  img').setAttribute('src', this.getAttribute('data-image'));
			// document.querySelector('#img_first  img').setAttribute('srcset', this.getAttribute('data-image'));
			document.querySelector('#colorOption').innerHTML = this.getAttribute('data-color-id');
		});

		dot.addEventListener('mouseout', function () {
			if (tempImage != '') {
				// document.querySelector('#img_first  img').setAttribute('src', tempImage);
				// document.querySelector('#img_first  img').setAttribute('srcset', tempSrcSet);
				document.querySelector('#colorOption').innerHTML = tempColorId;
			}
		});
	});

});